import CryptoJS from 'crypto-js';
import {BROWSER_OPTION} from '~/utils/constants';

class PortalStorage {
  constructor(iv, aesKey) {
    this.iv = CryptoJS.enc.Base64.parse(iv);
    this.aesKey = CryptoJS.enc.Base64.parse(aesKey);
  }


  portalSetItem = (key, text) => {
    const option = localStorage.getItem(BROWSER_OPTION);
    if (option === '1') {
      const encryptText = CryptoJS.AES.encrypt(text, this.aesKey, {iv: this.iv}).toString();
      localStorage.setItem(key, encryptText);
    } else {
      localStorage.setItem(key, text);
    }
  }

  portalGetItem = (key) => {
    const option = localStorage.getItem(BROWSER_OPTION);
    if (option === '1') {
      try {
        const encryptText = localStorage.getItem(key) || '';
        const bytes = CryptoJS.AES.decrypt(encryptText, this.aesKey, {iv: this.iv});
        const originalText = bytes.toString(CryptoJS.enc.Utf8);
        return originalText;
      } catch (error) {
        console.log(error);
        return '';
      }
    }
    return localStorage.getItem(key);
  }
}

export default function(iv, aesKey) {
  const instance = new PortalStorage(iv, aesKey);
  Storage.prototype.portalSetItem = instance.portalSetItem;
  Storage.prototype.portalGetItem = instance.portalGetItem;
}
